export default __webpack_public_path__ + "static/media/icon_store_bo.039f62a3.png";